import LogoWhite from "./logo_white.svg";
import emptyImage from "./emptyImage.png";
// import svg from "../../Assets/svg";

export const allCommonImages = {
  LogoWhite,
  emptyImage,

  // LogoBlack: svg.appLogo,
  // LogoWhite: svg.appLog,
};
